const toggleToolbar = (toolbarDOM, shouldShow) => {
  if (!toolbarDOM) {
    return;
  }

  Array.from(toolbarDOM.children).forEach((element) => {
    if (element.id !== "toolbar-btn") {
      element.style.display = shouldShow ? "" : "none";
    }
  });
};

const defaultFindOnPageBtnConfig = {
  flag: true,
  glyph: "find_in_page",
  title: "Find in Topic",
  input_placeholder: "Find in topic (all sections)",
};

export const showToolbarButtons = (toolbarDOM) =>
  toggleToolbar(toolbarDOM, true);
export const hideToolbarButtons = (toolbarDOM) =>
  toggleToolbar(toolbarDOM, false);

export const getFindOnPageBtnConfig = (userExperience, mode) => {
  return userExperience[mode] || defaultFindOnPageBtnConfig;
};
